import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { UploadFile } from 'ngx-uploader';


@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.css']
})
export class UploadProgressComponent implements OnInit {
  @Input() sourceFile: UploadFile;
  @Output() removeFile = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  removeSourceFile(id) {
    this.removeFile.emit(this.sourceFile.id);
  }


}
